export default __webpack_public_path__ + "static/media/photo-1-dark.62fb3007.jpg";